var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.439 25.896c3.534 4.944 12.472 4.61 19.962-.746s10.695-13.706 7.16-18.65c-3.536-4.944-12.474-4.61-19.964.746-7.49 5.356-10.695 13.706-7.16 18.65zm6.725-4.76c.07-1.556.947-5.28 3.9-7.73 2.952-2.452 6.383-2.508 7.73-2.23.046 1.324-.558 4.625-3.343 7.243-3.482 3.272-6.546 3.411-8.287 2.715z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpx);
export default __webpack_public_path__ + "static/media/EPX.f3ff341d4167c07ec34bf90680b89d37.svg";
export { ForwardRef as ReactComponent };